import { List } from './model/List_T';
import { View } from './model/view';
import { BooleanLiteral } from 'babel-types';

export class RelatedItemResolverConfig<TMainModel, TRelatedModel> {
  public idSelector: (main: TMainModel) => string;
  public itemChecker: (model: TMainModel) => boolean;
  public itemUpdater: (main: TMainModel, relaterd: TRelatedModel) => void;
  public relatedItemsGetter: (v: View) => TRelatedModel[];
  public defaultRelatedItem: TRelatedModel;

  constructor(options?: {
    idSelector: (main: TMainModel) => string,
    itemChecker: (model: TMainModel) => boolean,
    itemUpdater: (main: TMainModel, relaterd: TRelatedModel) => void,
    relatedItemsGetter: (v: View) => TRelatedModel[],
    defaultRelatedItem: TRelatedModel
  }) {

    if (options) {
      this.idSelector = options.idSelector;
      this.itemChecker = options.itemChecker;
      this.itemUpdater = options.itemUpdater;
      this.relatedItemsGetter = options.relatedItemsGetter;
      this.defaultRelatedItem = options.defaultRelatedItem;
    }
  }
}

export class RelatedItemResolver<TMainModel, TRelatedModel> {
  private config: RelatedItemResolverConfig<TMainModel, TRelatedModel>;

  constructor(config: RelatedItemResolverConfig<TMainModel, TRelatedModel>) {
    this.config = config;
  }

  public async resolve(list: List<TMainModel>) {
    const maxFetchCount = 40;
    const distinctIds = this.getDistinctRelatedIds(list);
    const dict = [];

    for (let pageIndex = 0; pageIndex < distinctIds.length; pageIndex += maxFetchCount) {

      const element = distinctIds.slice(pageIndex, pageIndex + maxFetchCount);
      const v = new View(500);

      v.addOrUpdateFilter('Id', element.join(';'));
      const relateditems = await this.config.relatedItemsGetter(v);

      relateditems.forEach(p => dict[p['id']] = p);

      this.fillRelatedInfo(list, dict, undefined);
    }

    this.fillRelatedInfo(list, dict, this.config.defaultRelatedItem);
  }

  private fillRelatedInfo(list: List<TMainModel>, dict: TRelatedModel[], def: TRelatedModel) {
    if (!dict) { return; }

    list.value.forEach(item => {
      if (this.config.itemChecker(item)) {
        const relateditem = dict[this.config.idSelector(item)];
        if (relateditem || def) {
          this.config.itemUpdater(item, relateditem || def);
        }
      }
    });
  }

  private getDistinctRelatedIds(list: List<TMainModel>) {
    const ids = [];

    if (!list || !list.value) return [];

    list.value.forEach(item => {
      const id = this.config.idSelector(item);

      if (id) {
        ids.push(id);
      }
    });

    return ids.filter((v, i, a) => a.indexOf(v) === i);
  }
}



// WEBPACK FOOTER //
// ./src/app/common/related.item.resolver.ts